import { SignBorrowContactContainer } from "../../../containers/borrowSystem/Contact/SignBorrowContactContainer"
export function SignBorrowContactPage (){
    return(
        <SignBorrowContactContainer />
    )
}